import { render, staticRenderFns } from "./BaseTableButton.vue?vue&type=template&id=537f720f&scoped=true&"
import script from "./BaseTableButton.vue?vue&type=script&lang=ts&"
export * from "./BaseTableButton.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTableButton.vue?vue&type=style&index=0&id=537f720f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f720f",
  null
  
)

export default component.exports